// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".admin-section-header[data-v-5a2c8df0]{text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
